<template>
    <div class="shopping-cart-tips">
        <p class="tips-text">{{tipsText}}</p>
        <i @click="event_closeTips" class="iconfont icon-guanbixiao"></i>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            tipsText: {
                type: String,
                default: ''
            }
        },
        methods: {
            // 关闭提示
            event_closeTips () {
                this.$store.commit('SET_TIPS_HIDE');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .shopping-cart-tips {
        display: flex;
        justify-content: space-between;
        width: 100%;
        /*height: toRem(80);*/
        line-height: toRem(80);
        padding: 0 toRem(30);
        background-color: $color-yellow;
        color: #FFF;
        font-family: Futura-Medium;
        font-size: toRem(28);
        @include box-sizing(border-box);
        .tips-text {
            overflow: hidden;
            @extend %text-ellipsis;
        }
        .iconfont {
            font-size: toRem(31);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/MTips/index.vue